import { Definitions } from './definitions.interface';

export const initialState: Definitions = {
  flow: {
    status: [],
    type: [],
    wholesaler: [],
  },
  order: {
    status: [],
    type: [],
    logisticsVarietyPacking: [],
    packingPerPallet: [],
    incoterm: [],
  },
  pallet: {
    status: [],
    type: [],
  },
  packing: {
    status: [],
    type: [],
  },
  transport: {
    type: [],
  },
  global: {
    type: [],
    brick: [],
  },
  places: [],
  loaded: false,
  loading: false,
  failed: false,
  invoices: {
    invoiceTypes: [],
  },
  language: null,
};
